module.exports = __webpack_public_path__ + "static/img/footerImg.50d7c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/footerImg.png
// module id = ef1F
// module chunks = 15